import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import AddressFormContent, { AddressFormRouteState } from '../common/AddressFormContent';
import styles from './index.module.scss';
import classNames from 'classnames';

interface AddressFormH5Props extends RouteComponentProps<{}, {}, AddressFormRouteState> {
    desktopMode?: boolean;
}

// H5 地址页面：复用业务表单，并使用移动端底部操作和底部抽屉样式。
class AddressFormH5 extends React.Component<AddressFormH5Props> {
    render() {
        return <div
            className={classNames(styles.layout, this.props.desktopMode && styles.desktopMode)}
        >
            <AddressFormContent
                {...this.props}
                styles={styles}
                mobileCascader
            />
        </div>;
    }
}

export default AddressFormH5;
